import {
  Modal,
  Button,
  Descriptions,
  Row,
  Card,
  Col,
  Flex,
  Typography,
  Space,
  Table,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import { getTagOrderStatus } from './order_status.type';
import { getTagPaymentStatus } from './payment.type';
import Currency from '../../components/Currency';
import dayjs from 'dayjs';
import useTime from '../../hooks/useTime';
import busOrdersApi from '../../api/bus_orders';
import 'dayjs/locale/fr';
import { formatCurrencyCustom } from '../../utils/helpers';

const { Text } = Typography;
const DetailBusOrder = (props) => {
  const { isModalOpen, currentData, onModalClose } = props;
  const { convertToAnyTimezone } = useTime();
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.firstname && record.lastname
          ? `${record.firstname}  ${record.lastname}`
          : '';
      },
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
    },
    {
      title: 'Siège',
      dataIndex: 'seat',
    },
    {
      title: 'Passeport',
      dataIndex: 'passport',
    },
    {
      title: '',
      dataIndex: '',
      render: (_, record) => {
        return (
          currentData.order_status === 'confirmed' &&
          currentData.pay_status === 'paid' && (
            <Button
              type="primary"
              onClick={() => sendSmSTicket(record)}
              size="small">
              SMS
            </Button>
          )
        );
      },
    },
  ];
  const sendSmSTicket = async (record) => {
    try {
      const res = await busOrdersApi.sendSmsTicket({
        booking_id: currentData.id,
        passenger_ids: [record.id],
      });
      if (res) {
        message.success('Send ticket Successfully');
      }
    } catch (err) {
      console.error(err);
    }
  };
  const items = [
    {
      key: '1',
      label: <IntlMessage id="global.orderId" />,
      children: <Text>{currentData?.order_no}</Text>,
      span: 2,
    },
    {
      key: '2',
      label: <IntlMessage id="global.sell_by" />,
      children: (
        <>
          <Space direction="vertical" size={'small'}>
            <Text>
              {convertToAnyTimezone(currentData?.created_at).format(
                'DD/MM/YYYY HH:mm',
              )}
            </Text>
            <Text>{currentData?.created_by?.fullname}</Text>
          </Space>
        </>
      ),
      span: 2,
    },
    {
      key: '3',
      label: <IntlMessage id="global.operator" />,
      children: (
        <>
          <Flex gap={4}>
            <Text>{currentData?.route?.operator?.title}</Text>
          </Flex>
        </>
      ),
      span: 2,
    },
    {
      key: '4',
      label: <IntlMessage id="global.customer" />,
      children: (
        <>
          <Space direction="vertical" size={'small'}>
            <Flex gap={4}>
              <span>Nom: </span>
              {currentData.pay_method === 'agent' ? (
                <Text>
                  {currentData?.passengers[0]?.firstname}{' '}
                  {currentData?.passengers[0]?.lastname}
                </Text>
              ) : (
                <Text>{currentData?.customer?.fullname}</Text>
              )}
            </Flex>
            <Flex gap={4}>
              <span>Tél: </span>
              {currentData.pay_method === 'agent' ? (
                <Text>{currentData?.passengers[0]?.phone}</Text>
              ) : (
                <>
                  <Text> {currentData?.customer?.phone_code}</Text>
                  <Text> {currentData?.customer?.mobile}</Text>
                </>
              )}
            </Flex>
          </Space>
        </>
      ),
      span: 2,
    },
    {
      key: '5',
      label: <IntlMessage id="order.pax" />,
      children: <Text>{currentData?.qty}</Text>,
      span: 2,
    },
    {
      key: '6',
      label: <IntlMessage id="global.roundtrip" />,
      children: <Text>{currentData?.roundtrip ? 'Yes' : 'No'}</Text>,
      span: 2,
    },
    {
      key: '7',
      label: <IntlMessage id="order.order_status" />,
      children: <Text>{getTagOrderStatus(currentData)}</Text>,
      span: 2,
    },
    {
      key: '8',
      label: <IntlMessage id="order.pay_status" />,
      children: <Text>{getTagPaymentStatus(currentData)}</Text>,
      span: 2,
    },
    {
      key: '9',
      label: <IntlMessage id="global.route" />,
      children: (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          {currentData?.order_items
            ? currentData.order_items.map((item, index) => {
                return (
                  <>
                    <Row style={{ fontWeight: '600' }}>
                      {item?.segment?.route?.start_location?.title &&
                      item?.segment?.route?.end_location?.title ? (
                        <Text>
                          {item?.segment?.route?.start_location?.title} - {''}
                          {item?.segment?.route?.end_location?.title}
                        </Text>
                      ) : (
                        ''
                      )}
                      {/* {item?.segment?.route?.operator?.title ? (
                        <Text>({item?.segment?.route?.operator?.title})</Text>
                      ) : (
                        ""
                      )} */}
                    </Row>
                    <Row gutter={[8, 8]}>
                      <Col span={12}>
                        <Text>
                          <span>Départ : </span>{' '}
                          <Text>
                            {dayjs(item?.date)
                              .locale('fr')
                              .format('dddd D MMMM YYYY')}
                          </Text>
                          <Text>
                            {' '}
                            {dayjs(item?.segment?.start_time, 'HH:mm:ss')
                              .locale('fr')
                              .format('HH:mm')}
                          </Text>
                        </Text>
                      </Col>
                      <Col span={12}>
                        <Text>
                          <span>Arrivée : </span>{' '}
                          <Text>
                            {dayjs(item?.date)
                              .locale('fr')
                              .format('dddd D MMMM YYYY')}
                          </Text>
                          <Text>
                            {' '}
                            {dayjs(item?.segment?.end_time, 'HH:mm:ss')
                              .locale('fr')
                              .format('HH:mm')}
                          </Text>
                        </Text>
                      </Col>
                    </Row>
                  </>
                );
              })
            : ''}
        </Space>
      ),
      span: 4,
    },
    {
      key: '10',
      label: <IntlMessage id="global.passengers" />,
      children: (
        <>
          {currentData?.passengers ? (
            <Table
              columns={columns}
              dataSource={currentData?.passengers}
              bordered
              pagination={{
                total: currentData?.passengers.length,
                pageSize: 5,
              }}
            />
          ) : null}
        </>
      ),
      span: 4,
    },
    {
      key: '11',
      label: <IntlMessage id="global.notes" />,
      children: <Text>{currentData?.notes ? currentData?.notes : ''}</Text>,
      span: 4,
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.order_details" />}
        open={isModalOpen}
        onCancel={onModalClose}
        width={'80%'}
        footer={[
          <>
            <Button key="back" type="primary" onClick={onModalClose}>
              {<IntlMessage id="global.ok" />}
            </Button>
          </>,
        ]}>
        <Row gutter={16}>
          <Col span={18}>
            <Descriptions
              bordered
              items={items}
              style={{ width: '100%', height: '100%' }}
            />
          </Col>

          <Col span={6}>
            <Card
              title={
                <>
                  <Row justify={'space-between'}>
                    <Col>
                      <Text>
                        <IntlMessage id="global.subtotal" />
                      </Text>
                    </Col>
                    {formatCurrencyCustom(
                      +currentData?.subtotal,
                      JSON.parse(currentData?.route?.operator?.params || '{}'),
                    )}
                  </Row>
                  <Row justify={'space-between'}>
                    <Col>
                      <Text>
                        <IntlMessage id="global.service_fee" />
                      </Text>
                    </Col>
                    <Col>
                      {formatCurrencyCustom(
                        +currentData?.service_fee,
                        JSON.parse(
                          currentData?.route?.operator?.params || '{}',
                        ),
                      )}
                    </Col>
                  </Row>
                  <Row justify={'space-between'}>
                    <Col>
                      <Text>
                        <IntlMessage id="global.total" />
                      </Text>
                    </Col>
                    <Col>
                      {JSON.parse(currentData?.params || '{}').booking_from ===
                      'agent' ? (
                        <Text>
                          {formatCurrencyCustom(
                            +currentData?.subtotal,
                            JSON.parse(
                              currentData?.route?.operator?.params || '{}',
                            ),
                          )}
                        </Text>
                      ) : (
                        formatCurrencyCustom(
                          +currentData?.total,
                          JSON.parse(
                            currentData?.route?.operator?.params || '{}',
                          ),
                        )
                      )}
                    </Col>
                  </Row>
                </>
              }></Card>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default DetailBusOrder;
